<template>
  <n-modal class="page-record-create" :loading="$var('load')" @close="$emit('close')">
    <div class="line">
      <n-card class="info" :loading="$var('load')">
        <template #header>
          <h3>Информация</h3>
        </template>
        <n-items>
          <n-input title="Проект" :value="project.title" text />
          <n-datepicker title="Дата заполнения" v-bind="$form.input('publishedAt')" />
        </n-items>
      </n-card>
    </div>
    
    <n-card :loading="$var('load')">
      <template #header>
        <h3>{{ journal.title }}</h3>
      </template>
      <n-items>
        <n-input title="Дата (число, месяц, год),смена" v-bind="$form.input('date')" />
        <n-input title="Наименование работ и применяемых материалов (пооперационно)" v-bind="$form.input('title')" />
        <n-input title="Объём работ" v-bind="$form.input('workValue')" />
        <n-input title="Температура во время выполнения работ, С: на поверхности материала" v-bind="$form.input('tempTop')" />
        <n-input title="Температура во время выполнения работ, С: окружающего воздуха на расстоянии не более 1 м от поверхности" v-bind="$form.input('tempAir')" />
        <n-input title="Применяемые материалы: ГОСТ, ОСТ, ТУ" v-bind="$form.input('materialGost')" />
        <n-input title="Применяемые материалы номер: паспорта" v-bind="$form.input('passportNumber')" />
        <n-input title="Применяемые материалы номер: анализа" v-bind="$form.input('analyzeNumber')" />
        <n-input title="Число нанесённых слоёв и их толщина, мм" v-bind="$form.input('layers')" />
        <n-input title="Температура, С, и продолжительность сушки отдельных слоёв покрытия" v-bind="$form.input('tempLayer')" />
        <n-input title="Фамилия и инициалы бригадира (специалиста), выполнявшего защитное покрытие" v-bind="$form.input('foreman')" />
        <n-input title="Дата и номер акта освидетельствования выполненных работ" v-bind="$form.input('dateAkt')" />
        <n-input title="Примечание" v-bind="$form.input('remark')" />
      </n-items>
    </n-card>
    
    <n-card>
      <n-divide>
        <div></div>
        <n-button color="success" @click="save">Сохранить</n-button>
      </n-divide>
    </n-card>
  </n-modal>
</template>

<script>
export default {
  name: 'PageRecordCreate',
  props: [ 'project', 'journal', ],
  data() {
    return {
      figures: [],
    }
  },
  created() {
    this.$form.init({
      publishedAt: $app.date.format($app.date.now()),
    })
  },
  methods: {
    save() {
      this.$var('load', true)
      const data = {
        record: this.$form.get(),
      }
      $api.journals.records.create(this.project.id, this.journal.name, data).then((response) => {
        this.$emit('reload')
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .page-record-create {
    
    .line {
      display: flex;
      align-items: flex-start;
      
      & > * {
        white-space: normal;
        display: inline-block;
        margin-bottom: 0;
        flex-grow: .4;
        flex-basis: 1px;
      }
      .items {
        margin-left: 0;
        flex-grow: .6;
      }
    }
    
    
    .weather {
      .unit {
        margin: 0 20px 0 5px;
      }
      .temperature {
        margin-left: 20px;
      }
      .temperature, .wind {
        width: 100px;
      }
    }
    
    .add {
      margin-top: 5px;
      font-size: .8em;
      opacity: .7;
      cursor: pointer;
    }
  }
</style>
